import { Image } from '@change/ds-core-ui/Image';
import { Text } from '@change/ds-core-ui/Text';
import { cn } from '@change/ds-utils';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import loadingImageUrl from '#src/assets/petition-loading-animation.animated.webp';

const descriptionKeys = [
	translationKey('corgi.start_a_petition.loading.description_1'),
	translationKey('corgi.start_a_petition.loading.description_2'),
	translationKey('corgi.start_a_petition.loading.description_3'),
	translationKey('corgi.start_a_petition.loading.description_4'),
	translationKey('corgi.start_a_petition.loading.description_5'),
] as const;

export const Loading: React.FC = () => {
	return (
		<div
			className="container mx-auto flex h-[calc(100vh-56px)] max-w-[620px] flex-col items-center justify-center gap-6 px-4 py-12 text-center md:justify-normal"
			data-testid="loading-screen"
		>
			<div>
				<Image src={loadingImageUrl} className="aspect-auto" width={220} height="auto" alt="" aria-hidden="true" />
			</div>

			<Text as="h2" variant="heading" className="w-[16ch] md:w-full">
				<Translate value="corgi.start_a_petition.loading.heading" />
			</Text>

			<div className="relative h-6 w-full overflow-hidden">
				{descriptionKeys.map((key, idx) => {
					const delay = idx * 2.5;

					return (
						<span
							key={key as unknown as string}
							className={cn(
								'absolute inset-0 grid place-items-center',
								'animate-fade-in-out',
								'will-change-opacity will-change-transform',
								idx === 0 ? 'motion-reduce:animate-none motion-reduce:opacity-100' : 'motion-reduce:hidden',
							)}
							style={{ animationDelay: `${delay}s` }}
						>
							<Text as="p" variant="body" size="medium" fontWeight="normal">
								<TypedTranslate value={key} />
							</Text>
						</span>
					);
				})}
			</div>
		</div>
	);
};
